import { render, staticRenderFns } from "./ActivityQuiz.vue?vue&type=template&id=dd1af0e4&scoped=true&"
import script from "./ActivityQuiz.vue?vue&type=script&lang=js&"
export * from "./ActivityQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1af0e4",
  null
  
)

export default component.exports